// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dca11931","453":"81821690","455":"fe12795c"}[chunkId] + ".chunk.js";
};